import { useEffect } from "react";
import { useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { resolveProduct } from "./resolveProduct";
import CheckoutFlow from "./CheckoutFlow";


const CheckoutPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const annualPlans = state?.annualPlans;
  const topUpPlans = state?.topUpPlans;

  const type = searchParams.get("type"); // "pack" | "plan"
  const id = searchParams.get("id");
  const cur = searchParams.get("cur") === "NGN" ? "NGN" : "USD";

  const product = resolveProduct({
    type,
    id,
    currency: cur,
    annualPlans,
    topUpPlans,
  });

  useEffect(() => {
    if (!product) navigate("/pricing", { replace: true });
  }, [product, navigate]);

  if (!product) return null;

  return (
    <CheckoutFlow
      product={product}
      productType={type}
      currency={cur}
      onBack={() => navigate("/pricing")}
    />
  );
};

export default CheckoutPage;
